import { getWindowObject } from '@eventbrite/feature-detection';
import React, { useEffect, useState } from 'react';
import type { Event } from '../../../../types/index';

export type TicketSelectionIframeProps = Pick<Event, 'id'>;

export const TicketSelectionIframe = ({ id }: TicketSelectionIframeProps) => {
    const [iframeWrapperHeight, setIframeWrapperHeight] = useState(204);
    const iframeContainerId = 'ticket-selection-listing-container';
    const compactCheckoutParams = { name: 'ticketsPageSize', value: 'compact' };

    useEffect(() => {
        getWindowObject('EBWidgets')?.createWidget({
            widgetType: 'checkout',
            eventId: id,
            iframeContainerId: iframeContainerId,
            extraParams: [compactCheckoutParams],
            iframeContainerHeight: iframeWrapperHeight,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getWindowObject('addEventListener')('message', (e: MessageEvent) =>
            setIframeWrapperHeight((e as any).iframeWrapperHeight),
        );
    }, []);

    return (
        <>
            <div
                id={iframeContainerId}
                style={{ height: `${iframeWrapperHeight}px` }}
            ></div>
        </>
    );
};
